import { BalanceDto } from 'api/ledger-client';

import { BalanceReportItem } from './BalanceReportItem';

export const BalanceReportList = ({
  entry,
}: {
  entry?: { EUR: BalanceDto; CHF: BalanceDto };
}) => <BalanceReportItem node={entry} />;
